import React from 'react';
import { Button } from '../../../../ui/components/Button';
import { faArrowLeft, faArrowRight, faCoffee } from '@fortawesome/free-solid-svg-icons';

interface StepNavigationProps {
    currentStep: number;
    isSubmitting: boolean;
    isFormValid: boolean;
    onBack: () => void;
    onNext: () => void;
    /** buzz on iOS; only where the bar sits outside the scrolling form (the mobile sheet footer) */
    iosTapOverlay?: boolean;
}

const StepNavigation: React.FC<StepNavigationProps> = ({ currentStep, isSubmitting, isFormValid, onBack, onNext, iosTapOverlay = false }) => {
    // both buttons are type="button": onBack/onNext already move the step, and on desktop this
    // bar renders inside the <form>, where a submit button would run handleSubmit a second time.
    return (
        <div className="flex items-center justify-between gap-2">
            <Button
                type="button"
                variant="soft"
                onClick={onBack}
                disabled={currentStep === 1 || isSubmitting}
                icon={faArrowLeft}
                iconPosition="left"
                size="sm"
                className="px-4"
                iosTapOverlay={iosTapOverlay}
            >
                Back
            </Button>
            <Button
                type="button"
                variant={isSubmitting || !isFormValid ? "soft" : "softPrimary"}
                onClick={onNext}
                disabled={isSubmitting || !isFormValid}
                loading={isSubmitting}
                icon={currentStep === 4 ? faCoffee : faArrowRight}
                iconPosition={currentStep === 4 ? 'left' : 'right'}
                size="sm"
                className="px-4"
                iosTapOverlay={iosTapOverlay}
            >
                {currentStep === 4 ? (isSubmitting ? 'Creating...' : 'Create Entry') : 'Next'}
            </Button>
        </div>
    );
};

export default StepNavigation;
